import React from "react";

import enUS from "./locales/en-US";
import zhCN from "./locales/zh-CN";

export const LANGUAGE_STORAGE_KEY = "musiness-language";
export const LanguageContext = React.createContext({
    language: "zh-CN",
    setLanguage: () => {},
    t: text => text,
});

export const getInitialLanguage = () => {
    const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored === "zh-CN" || stored === "en-US") {
        return stored;
    }
    return /^zh\b/i.test(window.navigator.language || "") ? "zh-CN" : "en-US";
};

export const translate = (text, language) =>
    language === "en-US" ? enUS[text] || text : zhCN[text] || text;

const isTranslationExcluded = node => {
    let element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    while (element) {
        if (
            element.classList.contains("notranslate") ||
            element.getAttribute("translate") === "no"
        ) {
            return true;
        }
        element = element.parentElement;
    }
    return false;
};

const translateTextNode = (node, language) => {
    if (isTranslationExcluded(node)) return;
    const original = node.__musinessOriginalText || node.nodeValue;
    node.__musinessOriginalText = original;
    const trimmed = original.trim();
    if (!trimmed) return;
    const translated = translate(trimmed, language);
    if (translated !== trimmed || language === "zh-CN") {
        node.nodeValue = original.replace(trimmed, translated);
    }
};

const translateElement = (element, language) => {
    if (isTranslationExcluded(element)) return;
    ["placeholder", "title", "aria-label"].forEach(attribute => {
        if (!element.hasAttribute || !element.hasAttribute(attribute)) return;
        const property = `__musinessOriginal_${attribute}`;
        const original = element[property] || element.getAttribute(attribute);
        element[property] = original;
        element.setAttribute(attribute, translate(original, language));
    });

    if (
        element.tagName === "INPUT" &&
        (element.type === "button" || element.type === "submit")
    ) {
        const original = element.__musinessOriginalValue || element.value;
        element.__musinessOriginalValue = original;
        element.value = translate(original, language);
    }
};

export const translateDom = (root, language) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) translateTextNode(root, language);
    if (root.nodeType === Node.ELEMENT_NODE) translateElement(root, language);
    const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT
    );
    let node = walker.nextNode();
    while (node) {
        if (node.nodeType === Node.TEXT_NODE) translateTextNode(node, language);
        else translateElement(node, language);
        node = walker.nextNode();
    }
};
